import React, { useRef } from "react";
import { CourseCheckout, WidePopup } from "@obby/components";
// @ts-ignore
import { TicketTypeBookingTypes } from "@obby/constants";
import * as settings from "~/settings";

export function CheckoutTermPopupView({
  course,
  locations,
  onClose,
  onCheckoutLogin,
  onConfirmFreeBooking,
  onGetPaymentIntent,
  onJoinWaitingList,
  onLoadMoreDates,
  onValidateDiscount,
  onViewTrialClick,
  ticketTypes,
  tutors,
  user
}: Props) {
  const popupWrapperRef = useRef<HTMLDivElement>(null);

  function onStepChange() {
    popupWrapperRef.current &&
      popupWrapperRef.current.scrollTo({
        top: 0
      });
  }

  return (
    <WidePopup onClose={onClose} wrapperRef={popupWrapperRef}>
      {/*@ts-ignore*/}
      <CourseCheckout
        course={course}
        courseId={course._id}
        courseThumbnail={course.galleryImagesHuge?.[0]?.url}
        courseTitle={course.title}
        courseType={course.type}
        discount={course.discount}
        isSendingMaterial={course.requiresSendingPhysicalMaterial}
        isOnline={course.isOnline}
        isSoldOut={course.summary.hasDates && !course.summary.hasAvailableDates}
        isTrialEnabled={course.summary.hasAvailableTermTrialDates}
        locations={locations}
        onConfirmFreeBooking={onConfirmFreeBooking}
        onGetPaymentIntent={onGetPaymentIntent}
        onLoadDates={onLoadMoreDates}
        onLogin={onCheckoutLogin}
        onStepChange={onStepChange}
        onValidateDiscount={onValidateDiscount}
        onViewTrialClick={onViewTrialClick}
        openWaitingListPopup={onJoinWaitingList}
        stripePublicKey={settings.stripe.publicKey}
        ticketTypes={ticketTypes}
        tutors={tutors}
        user={user}
        userInputs={course.userInputs}
      />
    </WidePopup>
  );
}
interface Props {
  course: any;
  locations: any[];
  onCheckoutLogin: () => void;
  onClose: () => void;
  onConfirmFreeBooking: (data: any) => void;
  onGetPaymentIntent: (data: any) => void;
  onJoinWaitingList: () => void;
  onLoadMoreDates: (args: LoadMoreDatesArgs) => Promise<any[]>;
  onValidateDiscount: (code: string, email: string) => Promise<any>;
  onViewTrialClick: () => void;
  ticketTypes: any[];
  tutors: any[];
  user?: any;
}

export interface LoadMoreDatesArgs {
  page: number;
  limit: number;
}
